import { render, staticRenderFns } from "./AddEmailRemainder.vue?vue&type=template&id=362c7766&scoped=true"
import script from "./AddEmailRemainder.vue?vue&type=script&lang=js"
export * from "./AddEmailRemainder.vue?vue&type=script&lang=js"
import style0 from "./AddEmailRemainder.vue?vue&type=style&index=0&id=362c7766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c7766",
  null
  
)

export default component.exports